import { render, staticRenderFns } from "./qixi.vue?vue&type=template&id=7609bacc&scoped=true&"
import script from "./qixi.vue?vue&type=script&lang=js&"
export * from "./qixi.vue?vue&type=script&lang=js&"
import style0 from "./qixi.vue?vue&type=style&index=0&id=7609bacc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7609bacc",
  null
  
)

export default component.exports